import { Link } from "react-router-dom";

export default function UpgradeCancel() {
  return (
    <div className="min-h-screen bg-ink-950 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <h1 className="font-display font-medium text-2xl text-white tracking-tight">
          No worries
        </h1>
        <p className="mt-3 text-white/60 text-base">
          You can upgrade to PRO anytime. Your free account is still fully functional.
        </p>
        <Link
          to="/#pricing"
          className="mt-8 inline-block text-figgy-400 hover:text-figgy-300 font-semibold text-sm transition"
        >
          &larr; Return to pricing
        </Link>
      </div>
    </div>
  );
}
